import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setZoomModeReducer = (state: EditorState, { payload: enable }: PayloadAction<boolean>) => {
  state.zoomMode = enable;
};

export default setZoomModeReducer;
